import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import Modal, { ModalProps } from "../../layouts/Modal";
import { IAccountAddress } from "./../../models/account/IAccountAddress";
import getAddress from "../../utils/getAddress";

interface AccountAddressModalProps
  extends Omit<ModalProps, "children" | "width"> {
  address?: IAccountAddress;
}

export function AccountAddressModal({
  address,
  open,
  setOpen,
}: AccountAddressModalProps) {
  const { t } = useTranslation("accounts");

  return (
    <Modal width="max-w-2xl" open={open} setOpen={setOpen}>
      <div className="p-4">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold">{t("Address Details")}</h2>
          <button
            onClick={() => setOpen(false)}
            className="text-gray-600 hover:text-gray-800"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="mt-4">
          <div className="flex items-center space-x-4">
            <p className="font-semibold">{t("Name:")}</p>
            <p>{address?.name}</p>
          </div>
          <div className="flex items-center space-x-4 mt-2">
            <p>
              {address
                ? getAddress(address)
                    .split(",")
                    .map((row) => (
                      <>
                        {row}
                        <br />
                      </>
                    ))
                : ""}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
